import * as types from "../actions/types";


const initialState = {
  data: null,
  loading: false
};


export default function scheduling_vd(state = initialState, action) {
  switch (action.type) {

    case types.SET_SCHEDULING_VD_LIST:
      return {
        ...state,
        dataVD: action.payload
      };

    case types.SET_SCHEDULING_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
}